export default {
  name: 'PricingSummary',
  props: {
    plan: Object,
    billingCycle: Number,
    label: String
  }
};